An opaque cursor to the earlier bounding event.

Resulting events will _succeed_ this cursor.
